import { toast } from 'sonner';
import { readAdminApiErrorMessage } from './adminUi';

export const showToast = {
  success: (message, options) => toast.success(message, options),
  error: (message, options) => toast.error(message, options),
  info: (message, options) => toast.info(message, options),
  warning: (message, options) => toast.warning(message, options),
  message: (message, options) => toast.message(message, options),
  promise: (promise, data) => toast.promise(promise, data),
  dismiss: (toastId) => toast.dismiss(toastId),

  /**
   * Dispatches an error toast by extracting messages from API Response objects,
   * standard Error instances, or plain strings.
   *
   * @param {Response|Error|string} errorOrResponse - The caught error or fetch response.
   * @param {string} [fallbackMessage='An unexpected error occurred.'] - Fallback error message.
   * @param {object} [options] - Additional sonner toast options.
   * @returns {Promise<string|number>}
   */
  apiError: async (errorOrResponse, fallbackMessage = 'An unexpected error occurred.', options) => {
    let resolvedMessage = fallbackMessage;

    if (errorOrResponse && typeof errorOrResponse.text === 'function' && typeof errorOrResponse.status === 'number') {
      try {
        resolvedMessage = await readAdminApiErrorMessage(errorOrResponse, { default: fallbackMessage });
      } catch {
        resolvedMessage = fallbackMessage;
      }
    } else if (errorOrResponse instanceof Error) {
      resolvedMessage = errorOrResponse.message || fallbackMessage;
    } else if (typeof errorOrResponse === 'string' && errorOrResponse.trim()) {
      resolvedMessage = errorOrResponse;
    }

    return toast.error(resolvedMessage, options);
  }
};

export { toast };
export default showToast;
